import { getBasedUrl } from './get-based-url';
import { isPageUrl } from './is-page-url';

export const getEditableUrl = (url: string, baseUrl?: string) =>
  typeof url !== 'string' ? undefined : isPageUrl(url) ? getBasedUrl(url, baseUrl || '') : url;
